import { Accordion } from "react-bootstrap";
import DetailItem from "../DataItem";
import { formatDate, formatTime } from "../../../../Utils/Common"; 
import { useState } from "react";
import ConfirmationModal from "../../../../Components/ConfirmationModal";
import { useEffect } from "react";
import { AdminService } from "../../../../Services/Admin.service";
import { DonorService } from "../../../../Services/Donor.Service";

const DonorSelectionAccordion = ({sampleRequestDetails, sampleTypeData, donorNotShow, updateDonorPunctuality, selectedRecruitedDonor, setSelectedRecruitedDonor, selectSpecialDonor, type})=>{
   
    useEffect(() => {
        if (
          sampleTypeData?.parent_id &&
          sampleRequestDetails?.request?.recruited_donors
        ) { 
          const donor = sampleRequestDetails?.request?.recruited_donors.find(
            (donation) => donation.parent_id === sampleTypeData.parent_id
          );
          if (donor) {
            setSelectedRecruitedDonor(donor);
          }
        }
      }, [
        sampleTypeData?.parent_id,
        sampleRequestDetails?.request?.recruited_donors,
      ]);
   
    const [isPunctual, setIsPunctual] = useState(null);
    
    const duration = {
        hours: 'Hours',
        minutes: 'Minutes',
    }
    const [unProcessUnit, setUnProcessUnit] = useState('minutes');
    const [lateDuration, setlateDuration] = useState();
    const [isNoShow, setIsNoShow] = useState(false);

    const [showDeleteModal, setShowDeleteModal] = useState(false); 

    const handleShowDeleteModal = () => setShowDeleteModal(true);
    const handleCloseDeleteModal = () => {
        setIsNoShow(false);
        setShowDeleteModal(false);
    }  
  
    const confirmDeleteUser = () => {
        handleCloseDeleteModal();
        donorNotShow({donor_id: selectedRecruitedDonor.donor_id, parent_id: selectedRecruitedDonor.parent_id});
    };
    
    const noShowCheckBox = (value) => {  
        if(selectedRecruitedDonor && value === true){ 
            setIsNoShow(value);
            handleShowDeleteModal();

        }
        else{
            alert("Please Select Any Recruited Donor");
        }
    }

    const handleDecimalNumber = (event) => {
        if (event.key === '.' || event.key ==="-"  || event.key ==="+" ) {
            event.preventDefault();
        }
    };
    useEffect(()=>{
        if(selectedRecruitedDonor?.punctual){ 
            
            if(selectedRecruitedDonor?.punctual == 'no'){
                setIsPunctual('No');
            }
            else if (selectedRecruitedDonor?.punctual == 'yes'){
                setIsPunctual('Yes');  
            }
            else{
                setIsPunctual(null);  
            }
        }


        if (selectedRecruitedDonor?.time_duration) {
            const [duration, unit] = selectedRecruitedDonor.time_duration.split(' ');
            setlateDuration(duration); // Set the numeric value (e.g., 2)
            setUnProcessUnit(unit);     // Set the unit (e.g., 'minutes' or 'hours')
        } 
    },[selectedRecruitedDonor]);


    const handlePunctualChange = (option) => {
        setIsPunctual(option);        
    };
    
    const handleLateDurationChange = (value) => {
        setlateDuration(value);        
    };
    
    const handleUnProcessUnitChange = (value) => {
        setUnProcessUnit(value);        
    };
    useEffect(() => {
        if (!selectedRecruitedDonor) return; // Do nothing if no donor is selected
   
        // Normalize values for comparison
        const donorPunctual = selectedRecruitedDonor.punctual?.toLowerCase();
        const [donorDuration, donorUnit] = selectedRecruitedDonor.time_duration
            ?.toLowerCase()
            .split(" ") || ["", ""];
    
        const normalizedPunctual = isPunctual?.toLowerCase();
        const normalizedDuration = lateDuration?.toString();
        const normalizedUnit = unProcessUnit?.toLowerCase();
    
        // Trigger only if values differ
        if (
            normalizedPunctual !== donorPunctual ||
            normalizedDuration !== donorDuration ||
            normalizedUnit !== donorUnit
        ) {
            triggerPunctualityUpdate(isPunctual, lateDuration, unProcessUnit);
        }
    }, [isPunctual, lateDuration, unProcessUnit, selectedRecruitedDonor]);
    
    
    
    const triggerPunctualityUpdate = (punctual, duration, unit) => {
        if (selectedRecruitedDonor) {
            // Check if all accepted samples are in donated samples
            const acceptedSamples = selectedRecruitedDonor?.accepted_samples
                ?.split(",")
                .map((sample) => sample.trim());
            const donatedSamples = selectedRecruitedDonor?.donated_samples
                ?.split(",")
                .map((sample) => sample.trim());
            
            const allCollected = acceptedSamples?.every((sample) =>
                donatedSamples?.includes(sample)
            );
    
            // If all samples are collected, do not proceed
            if (allCollected) {
                console.log("Donor punctuality update skipped: Samples already collected.");
                return;
            }
    
            if (isPunctual) { 
                if (isPunctual === "No" && !lateDuration) {
                    return;
                }
    
                const donorPunctual = {
                    donor_id: selectedRecruitedDonor.donor_id,
                    parent_id: selectedRecruitedDonor.parent_id,
                    punctual: punctual?.toLowerCase(),
                    duration,
                    type: unit,
                };
    
                console.log("Updating donor punctuality:", donorPunctual);
                updateDonorPunctuality(donorPunctual);
            }
        }
    };
    
    return (
        <>
        <Accordion.Item eventKey="6">
            <Accordion.Header><b>Donor Selection</b></Accordion.Header>
            <Accordion.Body> 
                <>
                    <DetailItem
                    title="Select Recruited Donor"
                    />
                    { sampleRequestDetails?.booked_count > 0 && sampleRequestDetails?.request?.recruited_donors ?
                    (<div className="">
                    <select
                        as="select"
                        name="recruited_donor"
                        className="form-control"
                        value={
                            selectedRecruitedDonor
                              ? JSON.stringify(selectedRecruitedDonor)
                              : ""
                          }
                        onChange={(e) => {  
                            if (e.target.value) {
                                const donor = JSON.parse(e.target.value); // Parse the donor details from the selected option
                                setSelectedRecruitedDonor(donor); 
                                // Handle punctuality
                                if (donor?.punctual === "no") {
                                    setIsPunctual("No");
                                } else if (donor?.punctual === "yes") {
                                    setIsPunctual("Yes");
                                } else {
                                    setIsPunctual(null);
                                    setlateDuration("");
                                    setUnProcessUnit('minutes');
                                }
                    
                                // Handle time duration
                                if (donor?.time_duration) {
                                    const [duration, unit] = donor.time_duration.split(" ");
                                    setlateDuration(duration); // Set the numeric value (e.g., 2)
                                    setUnProcessUnit(unit);    // Set the unit (e.g., 'minutes' or 'hours')
                                } else {
                                    setlateDuration("");
                                    setUnProcessUnit('minutes');
                                }
                            } else { 
                                setSelectedRecruitedDonor(null);
                                setIsPunctual(null);
                                setlateDuration("");
                                setUnProcessUnit('minutes');
                            }
                        }}
                    >    
                        <option value="">Select</option>  
                        
                         
                            {/* {sampleRequestDetails?.request?.recruited_donors.map((recruitedDonor, index) =>  
                            <>
                                <DetailItem 
                                    title="Donor ID"
                                    detail={ `${recruitedDonor.donor.donor_id}. Appointment Date : ${formatDate(recruitedDonor.appointment_date)} at ${formatTime(recruitedDonor.appointment_time)}` }
                                /> 
                            </>
                            )} */}
                        
                        {sampleRequestDetails?.request?.recruited_donors.map((donor) => (
                            
                            <option key={donor.donor.donor_id} id={donor.donor.donor_id}     value={JSON.stringify(donor)}>{ `${donor.donor.name}, ${formatDate(donor.appointment_date)} at ${formatTime(donor.appointment_time)}` }</option>
                        ))}  
                        
                        
                    </select>
                    </div>) : (<span className=" text-danger">Job not yet accepted by donor(s).</span>)}


                        <div className="mt-4 d-flex row align-items-center">
                                <div className="col-3 mb-2 radio-wrapper">
                                    <label htmlFor="punctual" className="form-label-check">Punctual</label>

                                    <div className="d-flex mt-1">
                                        {['Yes', 'No'].map((option) => (
                                            <div className="form-check" key={option}>
                                                <input
                                                    type="radio"
                                                    name="punctual"
                                                    value={option} // Set the value to the option (Yes or No)
                                                    checked={isPunctual === option} // Check if the current option matches isPunctual
                                                    // onChange={() => setIsPunctual(option)} // Update isPunctual on change
                                                    onChange={() => handlePunctualChange(option)} 
                                                    className="form-check-input radio-pointer"
                                                    autoComplete="off"
                                                    id={`punctual_${option}`}
                                                />
                                                <label htmlFor={`punctual_${option}`} className="form-check-label radio-pointer">&nbsp; {option}</label>
                                            </div>
                                        ))}
                                        
                                    </div>
                                </div>
                                    {  (isPunctual == 'No' || isPunctual == null )  && (
                                        <>
                                <div className="col-3">
                                            <input
                                                type="number"
                                                min={1}
                                                value={lateDuration}
                                                onKeyDown={handleDecimalNumber}
                                                // onChange={(e) => setlateDuration(e.target.value)} 
                                                onChange={(e) => handleLateDurationChange(e.target.value)} // Update lateDuration and trigger the API call
                                                placeholder="How late were they?"
                                                name="late_duration"
                                                className="form-control" autoComplete="off" 
                                            /> 
                                </div>
                           
                                <div className="col-3">
                                    <select 
                                        name={`unprocess_unit`}
                                        className="form-control"
                                        // onChange={(e) => setUnProcessUnit(e.target.value)}
                                        onChange={(e) => handleUnProcessUnitChange(e.target.value)}
                                        value={unProcessUnit} 
                                        autoComplete="off" 
                                    >
                                        {Object.entries(duration).map(([key, value]) => (
                                            <option key={key} value={key}>{value}</option>
                                        ))}
                                    </select>
                                </div>
                                        
                                        
                                    {/* { selectedRecruitedDonor && selectedRecruitedDonor?.donated_samples
                                        ?.split(',')
                                        .map((sample) => sample.trim())
                                        .includes(id.toString()) && (
                                            <>
                                                <div className="text-white bg-success el-sample-btn btn rounded p-2 ms-2">
                                                    <i className="el-active"></i> Collected
                                                </div>
                                            </>
                                        ))} */}
                                    {
                                        (
                                            !(
                                                selectedRecruitedDonor?.accepted_samples
                                                    ?.split(",")
                                                    .map((sample) => sample.trim())
                                                    .every((acceptedSample) =>
                                                        selectedRecruitedDonor?.donated_samples
                                                            ?.split(",")
                                                            .map((donatedSample) => donatedSample.trim())
                                                            .includes(acceptedSample)
                                                    )
                                            ) && (
                                                <>
                                                    <div className="col-1">
                                                        <label>Or</label>
                                                    </div>

                                                    <div className="col-2">
                                                        <div className="d-flex align-items-center">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input "
                                                            id={`checkbox-noshow`}
                                                            checked={isNoShow}
                                                            onChange={(e) => noShowCheckBox(e.target.checked)}
                                                            name="noshow"
                                                            style={{cursor:'pointer'}}
                                                        />
                                                        <label className="form-check-label ms-1" style={{cursor:'pointer'}} htmlFor={`checkbox-noshow`}>
                                                            No Show
                                                        </label>
                                                        </div>
                                                    </div>
                                                </>
                                            )
                                        )
                                    }

                                </>)}
                        </div>
                        {/* {(sampleRequestDetails?.booked_count < sampleRequestDetails?.total_volunteers) && ( */}
                        {(sampleRequestDetails?.booked_count < sampleRequestDetails?.request?.job_volunteer) && (
                            <> 
                                <hr/>  
                                <div>
                                    {/* {sampleTypeData.appointments} {sampleTypeData.total_donors} */}
                                    <button   disabled={sampleRequestDetails?.request?.status === 4 }   onClick={selectSpecialDonor} className="el-main-button btn"><i className=""></i><span>Unassigned Donor</span></button>
                                </div>
                            </> 
                        )}
                </>       
            </Accordion.Body>
        </Accordion.Item>
        <ConfirmationModal
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        onConfirm={confirmDeleteUser}
       
        body="Are you sure you want to do this?"
        type="donor-no-show"
      />
        </>
    );
}

export default DonorSelectionAccordion